@if (isGeolocationView()) {
  <app-geolocation-request />
}

@if (isWelcomeViewShown()) {
 <app-welcome-planner-view />
}

@switch(mobileViewsState()) {
  @case (customRouteMobileViews.planner) {
    <app-planner />
  }
  @case (customRouteMobileViews.chatbot) {
    <app-chatbot-custom-route-mobile />
  }
  @case (customRouteMobileViews.more) {
    <app-more />
  }
}

<app-map />

<app-menu-nav />